export const LANDING_TYPES = {
  // TODO Migrate leftover MERCHANT to SELLER in Browsing on backend side. https://backmarket.atlassian.net/browse/BRO-1900
  SELLER: 'MERCHANT',
  MODEL: 'MODEL',
}
